export default "__VITE_ASSET__C0xyh40x__"